var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin":"0 auto","width":"10px"}},[_c('div',{staticClass:"loader-dark-blue medium mb-5 mt-5"})])
}]

export { render, staticRenderFns }